import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import TextbausteinEdit from "../../newForms2/textbausteine/TextbausteinEdit";
import { deleteTextbausteinFromAPI } from "../../actions/textbausteine";

const TextbausteinDetails = ({ activeTextbaustein, backFunc }) => {
  const [showFormEdit, setShowFormEdit] = useState(false);
  const textbausteine = useSelector((st) => st.textbausteine);
  const dispatch = useDispatch();
  console.log({ textbausteine });
  const tb = textbausteine.find((tBa) => tBa.id === activeTextbaustein);

  const handleDelete = async () => {
    console.log("Löschen");
    dispatch(deleteTextbausteinFromAPI(activeTextbaustein));
    backFunc();
  };
  return (
    <>
      {!showFormEdit && (
        <div key={tb.id}>
          <h4>Detailansicht</h4>
          <p>Punkte: {tb.punkte}</p>
          <p>{`Baustein ${tb.number}`}</p>
          <p>{tb.text}</p>
          <Row>
            <Col>
              <button
                className="btn btn-outline-dark"
                onClick={() => setShowFormEdit(!showFormEdit)}
              >
                Bearbeiten
              </button>
            </Col>
            <Col>
              <button className="btn btn-danger" onClick={handleDelete}>
                Löschen
              </button>
            </Col>
            <Col>
              <button className="btn btn-outline-dark" onClick={backFunc}>
                Zurück zur Liste
              </button>
            </Col>
          </Row>
        </div>
      )}
      {showFormEdit && (
        <TextbausteinEdit id={tb.id} backFunc={() => setShowFormEdit(false)} />
      )}
    </>
  );
};
export default TextbausteinDetails;
